@if (pageInfo?.title) {
<div class="page-breadcrumb p-t-20 p-b-20 p-l-30 p-r-30">
  <div fxLayout="row">
    <div fxFlex.gt-sm="60" fxFlex.gt-xs="60" fxFlex="100" class="align-self-center">
      <h4 class="page-title text-themecolor m-0">{{pageInfo?.title}}</h4>
    </div>
    <div fxFlex.gt-sm="40" fxFlex.gt-xs="40" fxFlex="100" class="align-self-center">
      <div class="breadcrumb d-flex align-items-center float-right float-sm-left">
        <ul class="list-style-none d-flex align-items-center">
          @for (url of pageInfo?.urls; track url; let last = $last) {
          @if (!last) {
          <li class="breadcrumb-item" [routerLink]="url.url">
            <a href='javascript:void(0)'>{{url.title}}</a>
          </li>
          }
          @if (last) {
          <li class="breadcrumb-item active">{{url.title}}</li>
          }
          }
        </ul>
      </div>
    </div>
  </div>
</div>
}